import { configureStore } from '@reduxjs/toolkit';
import authReducer from '../redux/features/auth/authSlice';
import bannerReducer from '../redux/features/banner/bannerSlice';
import orderReducer from '../redux/features/order/orderSlice';
import inquiryReducer from '../redux/features/inquiry/inquirySlice';
import subscriptionReducer from '../redux/features/subscription/subscriptionSlice';
import courseReducer from '../redux/features/course/courseSlice';
import courseRegistrationReducer from '../redux/features/courseRegistration/courseRegistrationSlice';
import staffReducer from "../redux/features/staff/staffSlice";

const store = configureStore({
  reducer: {
    auth: authReducer,
    banner: bannerReducer,
    order: orderReducer,
    inquiry: inquiryReducer,
    subscription: subscriptionReducer,
    course: courseReducer,
    courseRegistration: courseRegistrationReducer,
    staff:staffReducer,
  },
});

export default store;
